module.exports = {"510302001":"五星街街道","510302002":"东兴寺街道","510302003":"新街街道","510302004":"郭家坳街街道","510302005":"丹桂街道","510302006":"学苑街道","510302007":"舒坪街道","510302008":"红旗街道","510302009":"高峰街道","510302101":"仲权镇","510302103":"荣边镇","510302104":"飞龙峡镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510302.json
// module id = 2405
// module chunks = 0